import { Dialog, DialogActions, DialogContent } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { FormattedMessage } from "react-intl";
import {useEffect, useState} from "react";
import {boxAction, BoxAudit, getAllElementBox} from "../../../reducers/Box/BoxReducer";
import {shedAction, ShedAudit} from "../../../reducers/Shed/ShedReducer";
import {useAppDispatch} from "../../../reducers/hooks";

interface ViewShedModalProps {
    open: boolean;
    onClose: () => void; // Passed as a prop
    boxData: string | undefined; // Data to display
}

export default function ViewBoxModal({
                                          open,
                                          onClose,
                                          boxData,
                                      }: ViewShedModalProps) {

    const [details, setDetails] = useState<BoxAudit | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const dispatch = useAppDispatch();
    useEffect(() => {
        if (boxData) { // Simplified the condition
            dispatch(boxAction(boxData));
        }
    }, [boxData]);

    return (
        <Dialog open={open} onClose={onClose} className="w-full max-w-2xl">
            <DialogTitle className="flex items-center justify-between border-b">
                <Typography variant="h5" className="text-xl font-semibold">
                    <FormattedMessage id="View Detail" defaultMessage="View Details" />
                </Typography>
            </DialogTitle>

            <DialogContent className="mt-4">
                <div className="p-4">
                    {loading ? (

                        <Typography>Caricamento in corso...</Typography>
                    ) : error ? (
                        <Typography color="error">{error}</Typography>
                    ) : details ? (

                        <>
                            <Typography variant="h6">TEST APERTURA:</Typography>
                        </>
                    ) : (
                        <Typography>Nessun dato disponibile.</Typography>
                    )}
                </div>
            </DialogContent>

            <DialogActions className="border-t p-4">
                <Button onClick={onClose} className="px-4 py-2">
                    <FormattedMessage id="Cancel" defaultMessage="Cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}
